import { render } from "./DetallesProyecto.vue?vue&type=template&id=a3857612&scoped=true"
import script from "./DetallesProyecto.vue?vue&type=script&lang=js"
export * from "./DetallesProyecto.vue?vue&type=script&lang=js"

import "./DetallesProyecto.vue?vue&type=style&index=0&id=a3857612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3857612"]])

export default __exports__